import { useMemo } from 'react';
import { findItemAndStack } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-connect/src/common/utils/find-item-stack/index.tsx';
import { useLocation } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/utils/use-location/index.tsx';
import { useRoute } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/utils/use-route/index.tsx';
import { useConnectApps } from '../connect-apps/index.tsx';

export const useIsConnectAppActive = () => {
	const location = useLocation();
	const route = useRoute();
	const { data: connectApps, error, loading } = useConnectApps();

	const isActive = useMemo(
		() => Boolean(findItemAndStack(connectApps, route.name, location)?.selected),
		[connectApps, location, route.name],
	);

	return { isActive, loading, error };
};
